import {
  desoLoginSuccess,
  setModalVisible,
  twitterSignOut,
} from "../../reducers/auth/action";
import HeroImage from "../../images/Svg/HeroImage.svg";
import Fade from "react-reveal/Fade";
import ArrowWhite from "../../images/Svg/ArrowWhite.svg";
import { Link, useNavigate } from "react-router-dom";
import { ConfigContext } from "../../context/config";
import useIdentity from "../../utils/identity";
import { useContext, useEffect, useState } from "react";
import LoginModal from "../Modal/Login.Modal";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { analytics } from "../../utils/firebase";
import { logEvent } from "firebase/analytics";

const Hero = () => {
  const { deso } = useSelector((state) => state?.auth);
  const [modalShow, setModalShow] = useState(false);
  const { identityWindow } = useContext(ConfigContext);
  const { handleMessage } = useIdentity();
  useEffect(() => {
    window.addEventListener("message", (event) =>
      handleMessage(event, identityWindow)
    );
  }, [identityWindow]);

  const h = 1000;
  const w = 800;
  const y = window.outerHeight / 2 + window.screenY - h / 2;
  const x = window.outerWidth / 2 + window.screenX - w / 2;

  const desoLogin = async () => {
    identityWindow.current = window.open(
      "https://identity.deso.org/log-in?accessLevelRequest=4",
      null,
      `toolbar=no, width=${w}, height=${h}, top=${y}, left=${x}`
    );
  };
  const navigation = useNavigate();

  const handleDashboard = () => {
    logEvent(analytics, "START_SHIFTING_NOW_CLICKED_HERO");
    if (deso?.user) {
      navigation("/dashboard");
    } else {
      setModalShow(true);
    }
  };

  return (
    <section
      className={`lg:pl-32 flex md:items-center flex-wrap  sm:flex-wrap md:flex-wrap mt-10 lg:flex-nowrap h-[700px] text-center sm:text-center lg:text-justify`}
    >
      <Fade cascade duration={1000}>
        <div>
          <div>
            <h1
              className={`text-black heroHeading font-bold whitespace-nowrap`}
            >
              <span className="mt-3">
                Launch into decentralised <br />
                social media for
              </span>

              <span className="text-blue"> FREE</span>
            </h1>
            <div className="lg:w-[50%] mt-[16px]">
              <p className="text-[#161616] text-center md:text-justify mx-[24px] sm:mx-[24px] md:mx-4 lg:mx-0">
                Setu helps creators launch into DeSo. Port your content from Web
                2 to decentralised social media seamlessly.
              </p>
            </div>
            <div className="button_hover mx:auto sm:mx-auto">
              <button
                onClick={handleDashboard}
                className="hero_button flex items-center my-[40px] sm:my-[40px] h-[56px] lg:my-[48px] bg-blue  w-[252px] rounded-[8px] justify-evenly  mx-auto sm:mx-auto lg:mx-0"
              >
                <span className="text-white">Start Shifting Now</span>{" "}
                <img src={ArrowWhite} alt="" />
              </button>
            </div>
          </div>
        </div>
      </Fade>
      <Fade cascade duration={1000}>
        <div>
          <div>
            <img src={HeroImage} />
          </div>
          {/* <img className="inline sm:inline md:inline lg:hidden" src={HeroImage} /> */}
        </div>
      </Fade>
      {modalShow ? (
        <LoginModal
          show={modalShow}
          setShow={setModalShow}
          desoLogin={desoLogin}
        />
      ) : null}
    </section>
  );
};

export default Hero;
